export const vars = {
  duration: 3600, // in seconds
  levels: 3,
  quests: 5,
  maxHints: 3,
  startTime: "2021-04-25T01:00:00.0+05:30",
};
